const getters = {
  token: state => state.user.token,
  url: state => state.user.url,
}
export default getters
